'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactRedux = require('react-redux');
var _reduxPagan = require('redux-pagan');
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);

var _components = require('../../components');

var _reportIssues = require('../../redux/modules/reportIssues');
var _checkRtlLanguage = require('../../utils/checkRtlLanguage');var _checkRtlLanguage2 = _interopRequireDefault(_checkRtlLanguage);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };} // Redux
// Modules
var ReportIssueModal = function ReportIssueModal(props) {return (
    _react2.default.createElement(_components.Modal, {
        isOpen: props.reportModalIsOpen,
        isCloseButtonInvisible: props.reportIssues.sent,
        onRequestClose: props.hideReportIssueModal,
        className: 'reportIssuesModal',
        isMobile: props.isMobile,
        translate: props.translate,
        isRtl: props.isRtl },

      _react2.default.createElement(_components.ReportIssue, {
        locale: props.locale,
        issueType: props.issueType,
        reportType: props.reportType,
        translate: props.translate,
        reportIssue: props.reportIssue,
        resetData: props.resetData,
        hideReportIssueModal: props.hideReportIssueModal,
        reportIssues: props.reportIssues,
        userData: props.userData })));}; // Components




ReportIssueModal.propTypes = {
  locale: _propTypes2.default.string,
  issueType: _propTypes2.default.string,
  reportType: _propTypes2.default.string,
  translate: _propTypes2.default.func,
  reportIssue: _propTypes2.default.func,
  resetData: _propTypes2.default.func,
  hideReportIssueModal: _propTypes2.default.func,
  reportIssues: _propTypes2.default.object,
  userData: _propTypes2.default.object,
  reportModalIsOpen: _propTypes2.default.bool,
  isMobile: _propTypes2.default.bool,
  isRtl: _propTypes2.default.bool };


var mapStateToProps = function mapStateToProps(state) {return {
    locale: state.lang.locale,
    translate: (0, _reduxPagan.getLang)(state.lang, 'static'),
    isMobile: state.windowDimentions.isMobile,
    isRtl: (0, _checkRtlLanguage2.default)(state.lang.locale),
    reportIssues: state.reportIssues,
    reportModalIsOpen: state.reportIssues.reportModalIsOpen,
    userData: state.userAuthentication.data,
    issueType: (0, _get2.default)(state, 'reportIssues.types.issueType'),
    reportType: (0, _get2.default)(state, 'reportIssues.types.reportType') };};exports.default =


(0, _reactRedux.connect)(mapStateToProps, {
  reportIssue: _reportIssues.reportIssue,
  resetData: _reportIssues.resetData,
  hideReportIssueModal: _reportIssues.hideReportIssueModal })(
ReportIssueModal);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/ReportIssueModal/ReportIssueModal.js
// module id = 3056
// module chunks = 0